import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { StatusType } from '../../constants/status.type';
import { StatusTextType } from '../../constants/status-text.type';
import { HearingRequestDetailsModel } from '../../models/hearing-request-details.model';
@Component({
  selector: 'jsg-action-hearing-history-view',
  templateUrl: './action-hearing-history-view.component.html',
  styleUrls: ['./action-hearing-history-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionHearingHistoryViewComponent implements OnInit {
  @Input() hearingHistory: HearingRequestDetailsModel[];
  @Input() hearingDetailsRoute: string;
  @Input() expanded: boolean;

  public FlexLayoutType = FlexLayoutType;
  public StatusType = StatusType;
  public StatusTextType = StatusTextType;
  constructor() {}

  ngOnInit(): void {}

  onToggleAdjournmentHistoryButton = (expanded: boolean) => {
    this.expanded = expanded;
  };
}
